import styled, { css } from 'styled-components'

import { COLORS } from 'consts/colors'
import { TButtonType } from './types'

const buttonStylesByType: Record<TButtonType, ReturnType<typeof css>> = {
  primary: css`
    background-color: ${COLORS.primaryDark};
    color: ${COLORS.white};

    & > svg path {
      fill: ${COLORS.white};
    }

    &:hover {
      background-color: ${COLORS.primaryExtraDark};
    }
  `,
  secondary: css`
    background-color: ${COLORS.primaryLight};
    color: ${COLORS.primaryDark};

    &:hover {
      color: ${COLORS.white};
      background-color: ${COLORS.primaryDark};
    }
  `,
  white: css`
    background-color: ${COLORS.white};
    color: ${COLORS.secondarySemiDark};

    &:hover {
      color: ${COLORS.secondaryDark};
    }
  `,
  light: css`
    background: ${COLORS.primaryLight};
    color: ${COLORS.primaryDark};
    &:hover {
      background: ${COLORS.primarySemiLight};
      color: ${COLORS.primaryExtraDark};
    }
  `
}

const disabledStyles = css`
  opacity: 0.5;
  cursor: default;
  pointer-events: none;
`

export const Button = styled.button<{
  $isDisabled?: boolean
  $type: TButtonType
}>`
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  gap: 10px;
  padding: 9px 23px;
  box-sizing: border-box;
  font-size: 14px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  ${({ $type }) => buttonStylesByType[$type]};
  ${({ $isDisabled }) => $isDisabled && disabledStyles};
`
